/**
 * 状态类：status { success、error、warn }
 * 弹窗类：dialog { toast、alert、confirm }
 * 表单类：from { placeholder、label }
 * 表格类：table { }
 *
 * 接口请求类：request
 * 接口响应类：responce
 *
 * 页面模块类：
 *
 */

// 使用 {{$t("purchase.periods")}}  //第*期

// 状态
const state = {
  preheatIng: "Préchauffage",
  purchaseIng: "Achat en cours",
  process: "En cours",
  over: "Terminé",
  finish: "Terminé",
  noData: "Aucune donnée",
};

// En-tête de la zone d'achat et de la page d'historique des achats personnels
const subheader = {
  pricePromise: "Garantie de prix, pas de baisse sous le prix d'émission",
  vipPrice: "Cashback VIP, prix avantageux",
  protection: "Garantie exclusive en devise fiduciaire",
  pricePromiseVal: "Garantie de prix de [*] jours, pas de baisse",
  rewards: "[*]% de rendement, prix garanti",
  vipDis: "Remise VIP, achat avantageux",
  zlz: "En cours d'aide",
};

// Zone d'achat
const purchase = {
  periods: "Série n°[*]",
  timesSheaves: "Tour n°[*]",
  supportPic: "Garantie de prix de [*] jours, pas de baisse",
  earnings: "[*]% de rendement, prix garanti",
  vipDiscount: "Remise VIP, achat avantageux",
  limit: "Quota de ce tour",
  timeLimit: "Prix limité dans le temps",
  schedule: "Progression actuelle",
  finishHalf: "[*]% terminé",
  subscriptionNum: "Quantité à acheter",
  vipText: "(VIP[*]) bénéficie d'une remise de ([**] [***] [****])", //（VIP6）享购买（2000COINS 5折）优惠
  supportType:"Méthode de garantie : Pendant la période de garantie, BiKing placera des ordres d'achat au prix minimum garanti sur le marché secondaire. L'utilisateur peut choisir de vendre ou non pendant cette période. Après la fin de la période, les ordres d'achat au prix minimum seront annulés.",
  beAbouttoAlipay: "Début imminent",
  atOnceAlipay: "Acheter maintenant",
  atOnceAlipayNew: "Aider maintenant",
  atOnceAlipayed: "Vous avez déjà acheté, veuillez attendre le prochain tour",
  atOnceAlipayedOver: "Vous avez déjà acheté, vous ne pouvez pas acheter à nouveau",
  atOnceAlipayedNew: "Vous avez déjà aidé, veuillez attendre le prochain tour",
  atOnceAlipayedNewOver: "Vous avez déjà aidé, vous ne pouvez pas participer à nouveau",
  website: "Site web",
  whitePaper: "Livre blanc",
  foreshow: "Aperçu de l'achat",
  startToUp: "Début de l'achat",
  startToUpNew: "Début de l'aide",
  distanceStartToUp: "Début dans",
  num: "Actuellement [*] personne(s) ont acheté [**] BAT",
  bannerText: "[*] a acheté un quota de [**]",
  bannerTextNew: "[*] a aidé un quota de [**]",
  nextProject: "Votre quota est épuisé, veuillez attendre le prochain projet",
  timesText: "Quota de ce tour épuisé, prochain tour le [*] mois [**] jour à [***]:[****]:[*****]",
  times: "[*] j [**] h [***] min [****] s",
  viewDetail: "Voir les détails",
  completePawd: "Définir le mot de passe de trading du compte",
  sureCoins: "Assurez-vous de détenir plus de [*] [**] (quantité minimale d'achat)",
  sureBalance: "Assurez-vous que le solde de [*] dans le compte est supérieur à [**]",
  set: "Configurer",
  available: "Quota achetable",
  holding: "Position du compte",
  startSoon: "L'achat va bientôt commencer",
  startSoonNew: "L'aide va bientôt commencer",
  projectSupp: "Quota du projet",
  projectSuppNew: "Limite d'aide",
  successBuy: "Achat réussi",
  successBuyNew: "Aide réussie",
  projectLimit: "Temps restant avant le début du projet",
  subscription: "Achat réussi",
  subscriptionNew: "Aide réussie",
  projectGoal: "Quota total d'achat de ce projet",
  projectGoalNew: "Quota d'aide de ce projet",
  goalFunds: "Achats déjà réalisés",
  goalFundsNew: "Aide déjà réalisée",
};

// Conditions d'achat
const purchaseCondition = {
  q: " et ",
  h: " ou ",
  cztj: "Assurez-vous du montant du dépôt",
  wqyh: "Réservé aux utilisateurs n'ayant pas participé aux éditions précédentes",
  vipdj: "Réservé aux utilisateurs VIP de niveau [*] et supérieur",
  condition: "Conditions d'achat",
  conditionNew: "Conditions d'aide",
  nameverify1: "Effectuer la vérification KYC pour la Chine continentale",
  nameverify2: "Effectuer la vérification KYC hors Chine continentale",
  nameverify3: "Effectuer la vérification KYC BiKing",
  login: "Veuillez vous connecter",
  maxBuyin: "Achat maximum",
  verify: "Effectuer la vérification KYC",
  affirm: "Assurez-vous que la position est supérieure à [*]",
  myPosition: "Ma position",
  AmountOfAscension: "Quota d'achat",
  AmountOfAscensionNew: "Quota d'aide",
  AmountOfAscensionText: "Plus la position quotidienne moyenne de [*] est élevée pendant les 7 jours précédant le début du premier tour, plus votre quota d'achat est élevé",
  AmountOfAscensionTime: "Ma position quotidienne moyenne de [*] sur 7 jours",
  discount: "Remise à l'achat",
  vip_discount: "Remise à l'aide",
  discountText: "Plus le niveau VIP est élevé, plus le prix d'achat est bas",
  upgrade: "Améliorer",
  vipUpgrade: "Mon VIP",
  zled: "Quota d'aide",
  wdzl: "Mon aide",
  zlxm: "Projet aidé",
  mlzl: "Aide par tour",
  zlmx: "Détails de l'aide",
  ccff: "Première distribution",
  qgmx: "Détails de l'achat",

  fjtj: "Conditions supplémentaires",
  guoji: "Nationalité",
  noJoin: "Non autorisé à participer",
  wancheng: "Terminer",
  pinggu: "Formulaire d'évaluation des risques d'investissement en cryptomonnaies",
  cyhd: "Participer à l'activité",
};

// Projets historiques
const historyProject = {
  rushLimit: "Quota d'achat",
  averagePic: "Prix moyen",
  averageNum: "Nombre d'acheteurs",
};

// Paiement
const alipay = {
  alipaynum: "Quantité à acheter",
  alipaynumNew: "Quota d'aide",
  ShouldPay: "À payer",
  VipDiscounts: "Remise VIP",
  VipWin: "Remise membre gagnant",
  willOpen: "Ouverture imminente",
  actualPayment: "Paiement réel",
  actualPaymentNew: "Aide de ce tour",
  importPassword: "Veuillez entrer le mot de passe de trading",
  forGetPassword: "Mot de passe de trading oublié ?",
  promptlyAlipay: "Payer maintenant",
  purchaseSuccess: "Félicitations, achat réussi",
  purchaseSuccessNew: "Félicitations, aide réussie",
  purchaseError: "Désolé, échec de l'achat, veuillez rafraîchir la page et réessayer",
};

// Détails du projet
const projectDetails = {
  text: "Assurez-vous de détenir plus de [*][**]",
  timelimitPic: "Prix limité",
  subscriptionLimit: "Quota d'achat",
  subscriptionLimitNew: "Quota d'aide",
  preheat: "Préchauffage",
  supportAbort: "Fin de la garantie de prix",
  unlockAbort: "Date de libération",
  projectIntroduction: "Présentation du projet",
  projectRole: "Règles de l'activité",
  rule: "Règles d'achat",
  ruleNew: "Règles d'aide",
};

// Fin de l'achat
const purchaseOver = {
  haveSubscribed: "Quota acheté",
  schedule: "Progression actuelle",
  Stime: "Heure de début de l'achat",
  StimeNew: "Heure de début de l'aide",
  Etime: "Heure de fin de l'achat",
  EtimeNew: "Heure de fin de l'aide",
  successText: "Ce projet a atteint son objectif de collecte de [*] BAT, collecte réussie !",
  success: "Succès",
};

// Mon achat
const myPurchase = {
  endUnlock: "Déblocage à la fin du dernier tour d'achat",
  endUnlock2: "Distribution à la fin du dernier tour d'achat",
  LText: "Déblocage quotidien pendant la période de garantie",
  WText: "Déblocage quotidien hors période de garantie",
  unlockend: "Débloqué",
  record: "Détails de l'achat",
  myPurchaseName: "Projets auxquels j'ai participé",
};

// mHeader
const mHeader = {
  sy: "Accueil",
  ksjy: "Trading rapide",
  zyjy: "Trading professionnel",
  c2c: "Trading C2C",
  otc: "Trading OTC",
  zczx: "Centre d'actifs",
  xwgg: "Actualités et annonces",
  xwgg1: "Annonces",
  lc: "BiKing Earn",
  gxlc: "Finance à haut rendement",
  dxjh: "FansUp!",
  fbjy: "Acheter des cryptos",
  dl: "Connexion",
  zc: "Inscription",
  jtzw: "Chinois simplifié",
  ftzw: "Chinois traditionnel",
  english: "English",
  kr: "한국어",
  qgms: "Achat flash",
  xsjy: "Transactions potentielles",
  // Reste de l'internationalisation
  zczgz: "Valorisation totale des actifs",
  yhzx: "Centre utilisateur",
  wdgl: "Gestion des ordres",
  tc: "Déconnexion",
  dltq: "Zone de faible liquidité",
  sdgm: "Achat flash",

  // téléchargement app
  appdown: "Télécharger l'APP",
  appdown1: "Télécharger",
  biking: "Application BiKing",
  gfqb: "Portefeuille officiel",
  xzbyapp: "Télécharger l'application BiKing",
  xzbyapp2: "Télécharger l'application BiKing",
  smewm: "Scanner le code QR",
  xzhyqb: "Télécharger le portefeuille HyperPay",
  xzhyqb2: "Télécharger le portefeuille HyperPay",
  bbjy: "Trading Spot",
  hyjy: "Contrat perpétuel",
  eftjy: "Trading ETF",
  byb: "Gagner des cryptos",
  newPos: "Pool minier HBT",
  HyperPay: "Gagner avec HyperPay",
  hqlc: "Minage POS",
  newlc: "Gagner",

  // Nouvel en-tête
  dd: "Ordres",
  zichan: "Actifs",
  xxzx: "Centre de messages",
  zhyaq: "Compte et sécurité",
  sfyz: "Vérification d'identité",
  wdvip: "Mon VIP",
  apigl: "Gestion API",
  hdzx: "Centre d'activités",
  wdhb: "Mes enveloppes rouges",
  flzx: "Centre de récompenses",
  bitloan: "Prêt crypto",
  ggjy: "Trading sur marge",
  hyxy: "Académie",
  flhd: "Activités de récompenses",
  bitWin: "Trésor BiKing",
};

// progress
const mProgress = {
  dqjd: "Progression actuelle",
  yjs: "Débloqué",
};

// res
const res = {
  // Erreurs d'achat
  seckill_project_000: "Erreur système",
  seckill_project_001: "Aucun projet disponible",
  seckill_project_002: "Les informations du projet n'existent pas",
  // Erreurs d'informations utilisateur
  seckill_userInfo_001: "Utilisateur inexistant",
  // Erreurs i18n
  i18n_no_table_001: "Système occupé",
  // Historique d'achat
  seckill_record_1: "Échec du paiement",
  // Règle de position sur 7 jours
  seckill_7days_1: "Aucune règle de position trouvée pour ce projet",
  // Portefeuille
  seckill_wallet_1: "Système occupé",
  seckill_wallet_2: "Solde du portefeuille insuffisant",
  seckill_wallet_3: "Échec du paiement",
  // Statistiques du projet
  seckill_record_count_1: "Erreur de données",
  seckill_record_count_2: "Échec du paiement",
  seckill_record_count_3: "Échec du paiement",
  // Tours du projet
  seckill_rounds_1: "Système occupé",
  seckill_rounds_2: "Aucun tour en cours d'achat trouvé pour ce projet",
  seckill_rounds_3: "Aucune information de tour trouvée pour ce projet",
  seckill_rounds_4: "Système occupé",
  seckill_rounds_5: "Aucune information de tour spécifique trouvée pour ce projet",
  // Informations projet
  seckill_pro_1: "Informations du projet non trouvées",
  seckill_pro_2: "Le quota d'achat est inférieur à la quantité minimale d'achat",
  seckill_pro_4: "Système occupé",
  seckill_pro_5: "Le projet n'est pas en ligne",
  // Paiement
  seckill_pay_1: "Système occupé",
  seckill_pay_2: "Système occupé",
  seckill_pay_3: "Informations du projet non trouvées",
  seckill_pay_4: "Le quota d'achat est inférieur à la quantité minimale d'achat",
  seckill_pay_5: "Le quota d'achat dépasse le quota restant de ce tour",
  seckill_pay_6: "Pas de quota d'achat",
  seckill_pay_7: "La quantité d'achat est supérieure au quota d'achat",
  seckill_pay_8: "Système occupé",
  seckill_pay_9: "Mot de passe de trading incorrect",
  seckill_pay_10: "Échec du paiement, veuillez réacheter",
  seckill_pay_11: "Échec du paiement, veuillez réacheter",
  seckill_pay_12: "Erreur d'informations utilisateur",
  seckill_pay_13: "Échec du paiement",
  seckill_pay_14: "Mot de passe de trading incorrect",
  seckill_pay_15: "Système occupé",
  seckill_pay_16: "Épuisé",
  seckill_pay_17: "Désolé, il y a trop de personnes en file d'attente, veuillez réessayer",
  seckill_pay_18: "Déjà acheté pour ce tour",
  seckill_pay_19: "Quota de ce tour épuisé",
  seckill_pay_20: "Veuillez d'abord vous connecter",
  seckill_pay_21: "Veuillez d'abord effectuer la vérification d'identité",
  seckill_pay_22: "Ce projet est réservé aux utilisateurs KYC de Chine continentale",
  seckill_pay_23: "Ce projet est réservé aux utilisateurs KYC hors Chine continentale",
  seckill_pay_24: "Trop de tentatives de mot de passe de trading, veuillez réessayer plus tard",
  seckill_hold_1: "La quantité de [*] que vous détenez ne remplit pas les conditions, veuillez en acheter avant de participer",
  // Questionnaire
  seckill_survey_submited: "Vous avez déjà soumis ce questionnaire",
  seckill_survey_error: "Erreur de traitement des informations du questionnaire",
  seckill_survey_info: "Aucune information de questionnaire trouvée pour ce projet",
};

const addContent = {
  hdjshy:'Temps restant avant la fin de l\'activité',
  qgsj: "Heure d'achat",
  qgsjNew: "Heure d'aide",
  gz: "Règles",
  zdjg: "Prix minimum",
  sq: "Réduire",
  qgms: "Achat flash",
  rgxm: "Projets participants",
  bled: "Quota de ce tour",
  dqjd: "Progression actuelle",
  yjs: "Débloqué",
  yff: "Distribué",
  qbcc: "Position à maintenir",
  cg: "Dépasser",
  jxmks: "Temps restant avant le début du projet",
  ycgrg: "Achat réussi",
  cgrg: "Achat réussi",
  xmed: "Quota du projet",
  cxmck: "Quota de collecte de ce projet",
  ckmb: "La collecte réelle a atteint l'objectif",
  ck: "Collecte",
  ckxq: "Voir les détails",
  kqed: "Quota achetable",
  zhcc: "Position du compte",
  jjks: "L'achat va bientôt commencer",
  mmsz: "Définir le mot de passe de trading du compte",
  qsz: "Configurer",
  qbye: "Assurez-vous que le solde de [*] dans le compte est supérieur à [**]",
  zjcz: "Assurez-vous que la position est supérieure à [*] [**] (quantité minimale d'achat)",
  jgdb: "Garantie de prix, pas de baisse sous le prix d'émission",
  jgyh: "Cashback VIP, prix avantageux",
  bwbj: "Garantie exclusive en devise fiduciaire",
  bj: "Garantie de prix de [*] jours, pas de baisse",
  sybj: "[*]% de rendement, prix garanti",
  zk: "Remise VIP, achat avantageux",
  r: "personnes",
  lsxm: "Projets historiques",
  bpf: "Aide communautaire, une vague d'avantages arrive",
  syybz: "Participation à faible seuil, avantages partagés",
  hg: "Devenez membre VIP, profitez de plus d'avantages",
  zgkx: "Jusqu'à [*] [**] de réduction",
  vip_zgkx: "Plus le niveau VIP est élevé, plus la réduction sur le prix total d'achat est importante. Le niveau VIP6 peut bénéficier d'une réduction de [*][**]",
  vip_zgkxNew: "Plus le niveau VIP est élevé, plus la réduction sur le montant total de l'aide est importante. Le niveau VIP6 peut bénéficier d'une réduction de [*][**]",
  blsysj: "Temps restant pour ce tour",
  blqbqw: "Quota de ce tour épuisé",
  xyl: "Prochain tour",
  zskq: "Début précis",
  bljshs: "Temps restant avant la fin de ce tour",
  zqyc: "Vous ne pouvez acheter qu'une fois par tour, revenez au prochain tour !",
  zxkf: "Vous n'êtes pas autorisé à participer à cette activité. Contactez le service client.",
  zqycNew: "Vous ne pouvez aider qu'une fois par tour, revenez au prochain tour !",
  wed: "Votre quota achetable pour ce projet est de 0, veuillez attendre le prochain projet",
  wedNew: "Votre quota d'aide pour ce projet est de 0, veuillez attendre le prochain projet",
  zsqg: "Quota d'achat minimum de [*][**], veuillez augmenter votre position avant d'acheter",
  srmm: "Veuillez entrer le mot de passe de trading",
  smrz: "Veuillez d'abord effectuer la vérification KYC",
  qszjymm: "Veuillez d'abord définir le mot de passe de trading",
  wenjuandiaocha: "Vous devez d'abord remplir le questionnaire pour participer à cette activité.",
  scqgms: "Festival des fans BiKing",
  hxyh: "Aidez la communauté BiKing, profitez d'avantages variés sans fin",
  zsqged: "Quota d'achat minimum de [*] [**]",
  zsqgedNew: "Quota d'aide minimum de [*] [**]",
  wmtj: "La quantité de [**] que vous détenez ne remplit pas les conditions, veuillez en acheter avant de participer",
  qjchqg: "Veuillez augmenter votre position avant d'acheter",
  qjchqgNew: "Veuillez augmenter votre position avant d'aider",
  rgjg: "Prix d'achat",
  qqg: "Acheter à prix réduit",
  wdqgjl: "Mon historique de participation",
  ckxmxq: "Voir les détails du projet",
  t: "j",
  yr: "[*] mois [**] jour",
  yrz: "Préchauffage du tour n°[*]",
  qgz: "Achat en cours du tour n°[*]",
  djlyjs: "Tour n°[*] terminé",
  dj: "Niveau VIP",
  xszk: "Taux de remise",
  jgzked: "Quota avec remise",
  zked: "Quota de remise",
  edw: "Hors quota, paiement au prix normal",
  qbcczd: "Assurez-vous de détenir plus de 1000 CWT (quantité minimale d'achat)",
  qrrjcc: "Position quotidienne moyenne sur 7 jours",
  jlblks: "Temps restant avant le début de ce tour",
  jlbljs: "Temps restant avant la fin de ce tour",
  zgkqed: "Quota maximum achetable",
  zgkzf: "Paiement maximum",
  cggmsl: "La quantité d'achat que vous avez saisie dépasse votre limite d'achat",
  bzzfzxgm: "La position actuelle est insuffisante pour payer la quantité minimale d'achat",
  bqzdqg: "Le quota d'achat minimum est de [*] [**]",
  zlzcLower: "Le quota d'aide minimum est de [*], le maximum est de [**]. Les jetons obtenus par l'aide seront crédités sur votre compte dans les 5 jours ouvrables suivant la fin de l'activité.",
  zgqged: "Le quota maximum est de [*] [**]",
  yzbz: "Remise exclusive pour les fans sur les devises de qualité",
  xszkj: "Prix à durée limitée",
  zlbxsq: "Achat flash de devises majeures",
  wks: "Pas encore commencé",
  jxz: "En cours",
  qgsl: "Quantité à acheter",
  wcydxm: "Projets auxquels j'ai participé",
  bjq: "Période de cotation",
  hgq: "Période de rachat",
  qzk: "Acheter à prix réduit",
  qxzl: "Aidez d'abord pour gagner des jetons",
  ds: "Limite d'aide",
  dhbl: "Taux d'échange",
  jicj: "Prix de base",
  jiagzd: "Le prix final sera déterminé dans les 3 heures précédant le début de l'achat",
  zdyh: "Remise maximale",
};

const hyy = {
  bkt: "Ne pas activer",
  wqdkt: "Je confirme l'activation",
  kt12: "1. Vous devez comprendre en détail les connaissances de base et les risques liés au trading de contrats sur actifs numériques ainsi que toutes les règles commerciales relatives aux transactions sur produits dérivés avant d'y participer.",
  kt13: "2. Cette déclaration de risques n'est qu'une énumération et ne liste pas de manière exhaustive tous les facteurs de risque liés au trading de produits dérivés sur actifs numériques. Les investisseurs doivent également comprendre et maîtriser les autres risques potentiels avant d'investir.",
  kt14: "3. Nous vous conseillons sincèrement de décider prudemment de participer ou non à ce trading de contrats en fonction de votre propre situation (tolérance au risque, etc.) et de configurer rationnellement vos actifs numériques.",
  kt0: "Cher utilisateur :",
  kt1: "Vous n'avez pas encore activé le compte Futures et les autorisations de trading associées. Veuillez lire attentivement ce qui suit avant de décider d'activer :",
  kt2: "1. Si vous tradez sur le marché des contrats à terme et que l'évolution des prix vous est défavorable, entraînant une marge de position insuffisante, le contrat perpétuel BiKing exécutera une liquidation forcée de votre position selon les règles du système et divulguera les détails de la liquidation.",
  kt3: "2. Vous devez lire attentivement et respecter les règles commerciales du contrat perpétuel BiKing, comprendre le mécanisme et le principe de fonctionnement du contrat, ainsi que les différents risques du marché.",
  kt4: "4. Le contrat perpétuel BiKing est connecté au système de trading de contrats. Les bénéfices/pertes de la position de l'utilisateur fluctuent avec les mouvements du marché. En cas de perte importante, une liquidation peut également se produire. L'utilisateur doit prendre ses propres décisions de trading en fonction de la situation du marché et assumer ses propres bénéfices/pertes. En conséquence, BiKing n'offre aucune garantie implicite ou explicite.",
  kt5: "5. Dans certaines conditions de marché extrêmes, il peut être difficile, voire impossible, de liquider vos positions ouvertes. Par exemple, si votre bénéfice se classe premier en termes de PnL à effet de levier sur l'ensemble du marché et que la contrepartie ne dispose pas de suffisamment de fonds dans le fonds d'assurance pour couvrir sa perte de liquidation.",
  kt6: "6. Le trading de produits dérivés sur actifs numériques peut être soumis à des risques réglementaires dans certaines juridictions. Vous devez juger prudemment après avoir compris le contexte réglementaire de votre zone de trading. En raison de changements légaux/réglementaires, de modifications des règles de la bourse de contrats ou de mesures d'urgence, BiKing publiera une déclaration préalable. Vos positions ouvertes pourraient ne pas pouvoir être maintenues, mais les marges et les bénéfices restants seront tout de même réalisés.",
  kt7: "7. En raison de circonstances indépendantes de la volonté de la plateforme (catastrophes naturelles, pannes informatiques, etc.), vos ordres pourraient ne pas être exécutés ou partiellement exécutés. Les pertes qui en résultent pourraient être à votre charge.",
  kt8: "8. Le trading de couverture, tout comme le trading spéculatif, est également confronté aux risques liés aux fluctuations des prix.",
  kta9: "9. Si vous n'avez pas effectué de vérification d'identité ou lié Google Authenticator, ou si vous prêtez votre compte à des tiers, la sécurité de votre marge de contrat pourrait être affectée.",
  kta10:"3. Dans certaines conditions de marché extrêmes, il peut être difficile, voire impossible, de liquider vos positions ouvertes. Par exemple, si votre bénéfice se classe premier en termes de PnL à effet de levier sur l'ensemble du marché et que la contrepartie ne dispose pas de suffisamment de fonds dans le fonds d'assurance pour couvrir sa perte de liquidation.",
  kt9: "J'ai lu attentivement et j'accepte les risques",
  kt10: "Activer le compte Futures et les autorisations",
  zjhz: "Transfert de fonds",
  ljhz: "Transférer",
  qx: "Annuler le transfert",
  khz: "Transferable",
  qxz: "Sélectionner",
  bz: "Devise",
  c: "De",
  zz: "Vers",
  sl: "Quantité",
  qb: "Tout",
  ktcg: "Activation réussie",
  ktsb: "Échec de l'activation",
  hzcg: "Transfert réussi",
  hzsb: "Échec du transfert",
  wyyd: "",
  tc: "Quitter",
  warning1: "Veuillez sélectionner une devise",
  warning2: "Le compte source ne peut pas être vide",
  warning3: "Le compte destinataire ne peut pas être vide",
  warning4: "Veuillez entrer un nombre ne dépassant pas le montant transférable",
  gb: "Fermer",
  openSuccess: "Vous avez activé le trading de contrats",
  openSuccessTip: "Veuillez transférer des fonds vers votre compte Futures",
  warning5: "Maximum 4 décimales",
  not_get_nm: "Désolé, l'offre NNT est terminée, ce transfert n'a pas donné lieu à des NNT.",
};

const trading = {
  gflj: 'Lien officiel',
  gw: 'Site officiel',
  qkllq: 'Explorateur de blocs',
  scfxsj: 'Date de première émission',
  fxzl: 'Offre totale',
  ltzl: 'Offre en circulation',
  jy: 'Transaction',
  sj: 'Prix du marché',
  tbxx: 'Informations graphiques',
  bzgk: 'Aperçu de la devise',
  ddb: 'Tableau des ordres',
  zxcj: 'Dernières transactions',

  reload: "Actualiser",
  socketError: "Erreur réseau, veuillez",
  noData: "Aucune donnée",
  entrustorder: "Carnet d'ordres",
  prices: "Prix",
  quantity: "Quantité",
  grandtotal: "Cumulé",
  transamount: "Montant",
  time: "Heure",
  available: "Disponible",
  limitorder: "Limite",
  plancommission: "Ordre planifié",
  currentcommission: "Ordres en cours",
  historycommission: "Ordres historiques",
  completecommission: "Ordres exécutés",
  funds: 'Fonds',
  hidetrading: "Masquer les autres paires de trading",
  morecurrentcommission: "Plus d'ordres en cours",
  morehistorycommission: "Plus d'ordres historiques",
  moredocommission: "Plus d'ordres exécutés",
  realtimetrans: "Transactions en temps réel",
  myassets: "Mes actifs",
  detail: "Détails",
  buyin: "Acheter",
  sellout: "Vendre",
  login: "Connexion",
  transfer: "Transférer",
  recharge: "Déposer",
  withdrawal: "Acheter des cryptos",
  quickpurchase: "Achat rapide en fiat",
  default: "Défaut",
  ordertime: "Heure de l'ordre",
  tradingpair: "Paire de trading",
  direction: "Direction",
  types: "Type",
  commissionprice: "Prix de l'ordre",
  commissionnumber: "Quantité de l'ordre",
  dealprice: "Prix moyen exécuté",
  dealnumber: "Quantité exécutée",
  triggerprice: "Prix de déclenchement",
  cancelall: "Annuler tous les ordres",
  averageprice: "Prix moyen",
  totalsum: "Total",
  fixedprice: "Prix limité",
  marketprice: "Prix du marché",
  codeExpired: "QR code expiré",
  clickRefresh: "Cliquez pour actualiser",
  QRsuccessfully: "Scan réussi",
  loginInApp: "Veuillez confirmer la connexion dans l'APP",
  backtoQR: "Retour à la connexion par QR code",
  loginSuccess: "Vous êtes connecté, bienvenue sur BiKing !",
  loadingText: "Chargement...",
  searchPlaceholder: "Rechercher",
  all: "Tous",
  currency: "Devise",
  price: "Dernier prix",
  market: "Classement des hausses",
  increase: "Hausse",
  highestPrice: "Plus haut",
  minimumPrice: "Plus bas",
  turnover: "Volume",
  jydlb: "Liste des paires de trading",
  bzjs: "Présentation de la devise",
  currencyTransaction: "Trading Spot",
  leveragedTransaction: "Trading sur marge",
  warning: "Avertissement : Le fork de Bitcoin Cash est très incertain. Le trading ou l'investissement dans des jetons à terme de fork comporte des risques extrêmement élevés. Si une chaîne manque de support minier, elle peut ne pas survivre et les jetons associés risquent de tomber à zéro. BiKing ne donne aucune garantie quant à la valeur de tout jeton à terme de fork !",
  zb: "Indicateurs",
  date: "Date",
  UpAnddown: "Hausse/Baisse",
  amplitude: "Amplitude",
  0: "Temps réel",
  1: "1 min",
  5: "5 min",
  15: "15 min",
  30: "30 min",
  60: "1 h",
  240: "4 h",
  3600: "1 j",
  10800: "1 s",
  dates: "Période :",
  password: "Mot de passe de trading",
  errorPassword: "Veuillez entrer le bon mot de passe de trading",
  worningPassword: "Veuillez entrer le mot de passe de trading",
  cancel: "Annuler",
  sure: "Confirmer",
  canBuy: "Achetable",
  canCell: "Vendable",
  withdraw: "Retirer",
  otc: "OTC, entrée et sortie rapides en fiat",
  enterPrice: "Veuillez entrer le prix",
  sellingPrice: "Prix de vente",
  purchasePrice: "Prix d'achat",
  salesVolume: "Volume de vente",
  buyingVolume: "Volume d'achat",
  volume: "Montant",
  serviceCharge: "Frais",
  vip: "Améliorez votre VIP pour bénéficier d'une réduction immédiate sur les frais",
  or: "ou",
  register: "S'inscrire",
  totalPrice: "Le montant ne peut pas dépasser",
  amountTip: "Veuillez entrer une quantité valide",
  amountTipError: "La quantité ne peut pas dépasser",
  limitTrading: "Ordre limité",
  priceReminder: "Alerte de prix",
  SMSReminder: "Alerte SMS",
  loginAccount: "Compte de connexion",
  phone: "Téléphone",
  phoneNum: "Veuillez entrer le numéro de téléphone",
  phoneTips: "Veuillez entrer un numéro de téléphone valide",
  email: "E-mail",
  emailNum: "Veuillez entrer l'e-mail",
  emailTips: "Veuillez entrer un e-mail valide",
  aears: "Veuillez sélectionner l'indicatif",
  passwordError: "Veuillez entrer le bon mot de passe",
  passwordTips: "Veuillez entrer le mot de passe",
  forgetPassword: "Mot de passe oublié",
  noAccount: "Pas de compte",
  goRegister: "S'inscrire maintenant",
  appsys: "Connexion sécurisée par scan APP",
  xzapp: "Télécharger la dernière APP",
  mmdl: "Connexion par mot de passe",
  smdl: "Connexion par scan",
  google: "Google Authenticator",
  nybd: "Vous avez déjà lié",
  zqyzm: "Veuillez entrer un code de validation correct",
  fsyzm: "Envoyer le code",
  flv: "Taux",
  jz: "Valeur nette",
  jzdesc1: "Valeur nette haussière = Valeur nette du dernier ajustement * [1+3*(Prix de transaction spot actuel - Prix du dernier ajustement spot)/Prix du dernier ajustement spot*100%] ;",
  jzdesc2: "Valeur nette baissière = Valeur nette du dernier ajustement * [1-3*(Prix de transaction spot actuel - Prix du dernier ajustement spot)/Prix du dernier ajustement spot*100%] ;",
  sbd: "3x long",
  sbs: "3x short",
  flvjs: 'Les frais de financement ETF sont des frais de gestion quotidiens prélevés par la plateforme sur l\'effet de levier pour payer les frais de financement générés par le portefeuille. Les frais de gestion se reflètent dans le changement de valeur nette, c\'est-à-dire qu\'ils sont présentés sous forme de "déduction de la valeur de l\'ETF à effet de levier", et ne sont prélevés qu\'à 0h00 (heure de Singapour). Si vous ne détenez pas le produit à ce moment, aucun frais ne sera facturé.',
  mzsm: "Clause de non-responsabilité",
  ido: "J'ai lu et j'accepte",
  exemption1: "Cher client, bonjour !",
  exemption2: "Merci d'utiliser les produits ETF et services associés (ci-après dénommés 'produits ETF') fournis par la plateforme BiKing (BiKing.ai). Veuillez lire attentivement la description des produits ETF et l'avertissement suivant. En continuant à utiliser les produits ETF après avoir lu, vous reconnaissez avoir pleinement compris les risques des produits ETF, être capable de supporter les pertes potentielles, et accepter l'intégralité de cette clause de non-responsabilité. Veuillez cliquer pour lire la description :",
  exemption3: "FAQ sur les produits ETF à effet de levier",
  exemption4: "Avertissement :",
  exemption5: "1. Le prix auquel vous achetez/vendez ne doit pas s'écarter considérablement de la valeur nette unitaire, faute de quoi vous subirez des pertes.",
  exemption6: "2. En cas d'erreur de direction, dans des conditions de marché extrêmes, le prix peut tendre vers zéro.",
  exemption7: "BiKing vous rappelle solennellement que les pertes ou responsabilités résultant des risques susmentionnés sont entièrement à votre charge, et BiKing n'assume aucune responsabilité à cet égard. Cette clause de non-responsabilité, ainsi que d'autres accords, déclarations et règles au sein de la plateforme BiKing, constituent l'intégralité de l'accord entre BiKing et vous concernant les services et produits de BiKing.",
  bzjs1: "1. '3L' signifie que si le prix de la paire de trading sous-jacente augmente de 1%, la valeur nette du produit augmente de 3%",
  bzjs2: "2. '3S' signifie que si le prix de la paire de trading sous-jacente diminue de 1%, la valeur nette du produit augmente de 3%",
  bzjs3: "3. La valeur nette est ajustée quotidiennement à 0h00, et peut être ajustée pendant la séance en cas de conditions de marché extrêmes",
  bzjs4: "4. Des frais de gestion correspondant à chaque effet de levier sont prélevés quotidiennement",
  bzjs5: "5. Veuillez vérifier la valeur nette avant de trader. Dans des conditions de marché extrêmes, le prix peut tendre vers zéro et s'écarter considérablement de la valeur nette. Les investisseurs doivent contrôler les risques",
  gdjk: "Plus de détails dans l'annonce",
  firstTrading: "Veuillez d'abord définir le mot de passe de trading avant votre première transaction",
  status: "Statut",
  status1: "En attente de correspondance",
  status2: "Non exécuté",
  status3: "Annulé par l'utilisateur",
  status4: "Partiellement exécuté",
  status5: "Entièrement exécuté",
  status6: "Invalide",
  allCancel: "Annuler tous les ordres",
  canceld: "Annuler",
  cancelsuccess: "Tous les ordres annulés avec succès, [*] ordre(s) annulé(s)",
  VIP1: "Votre niveau VIP",
  VIP2: "Frais de trading plus bas, expérience de trading de meilleure qualité",
  VIP3: "Taker :",
  VIP4: "Maker :",
  buyAmount: "La quantité d'achat ne peut pas dépasser",
  sellAmount: "La quantité de vente ne peut pas dépasser",
  buyAmountMin: "Votre solde achetable est insuffisant",
  sellAmountMin: "Votre solde vendable est insuffisant",
};

const common = {
  wan: "10k",
  qian: "1k",
  yi: "100M",
};

const transferDialog = {
  划转: "Transférer",
  资金互转: "Transfert de fonds",
  币币账户: "Compte Spot",
  买币账户: "Compte d'achat",
  已冻结: "Gelé",
  合约账户: "Compte Futures",
  未开通: "Non activé",
  杠杆账户: "Compte sur marge",
  币贷宝账户: "Compte de prêt crypto",
  从: "De",
  转至: "Vers",
  币种: "Devise",
  数量: "Quantité",
  全部: "Tout",
  用户未归还借贷的情况下: "Lorsque l'utilisateur n'a pas remboursé son prêt, les fonds avec un taux de risque supérieur à 200% peuvent être transférés",
  可划转: "Transferable",
  一阶: "1. Niveau 1",
  累计净划入: "Transfert net cumulé",
  可获得: "Peut recevoir",
  泥码: "NNT",
  二阶: "2. Niveau 2",
  您尚未完成实名认证: "Vous n'avez pas encore effectué la vérification d'identité",
  余额: "Solde",
  立即划转: "Transférer",
  资产划转: "Transfert d'actifs",
  用于维持现有仓位的保证金: "Utilisé pour maintenir les positions actuelles",
  归还数量: "Quantité à rembourser",
  您的币贷宝账户尚未开通: "Votre compte de prêt crypto n'est pas encore activé, veuillez l'activer d'abord",
  请输入正确的数量: "Veuillez entrer une quantité valide",
  划转金额不能为: "Le montant du transfert ne peut pas être 0",
  账户可用余额不足: "Solde disponible du compte insuffisant",
  划转失败: "Échec du transfert",
  划转成功: "Transfert réussi",
  本次划转未能获得泥码: "Désolé, l'offre NNT est terminée, ce transfert n'a pas donné lieu à des NNT",
  您只需再向合约账户划转: "Il vous suffit de transférer [*] USDT supplémentaires vers votre compte Futures pour recevoir [**] USDT de NNT",
  您向合约账户: "Transfert net cumulé de [*] USDT vers votre compte Futures pour recevoir",
  请输入划转数量: "Veuillez entrer la quantité à transférer",
};

export {
  state,
  subheader,
  purchase,
  purchaseCondition,
  historyProject,
  alipay,
  projectDetails,
  purchaseOver,
  myPurchase,
  mHeader,
  res,
  addContent,
  hyy,
  trading,
  common,
  transferDialog,
};


// WEBPACK FOOTER //
// ./src/i18n/lang/fr.js